module.exports = __webpack_public_path__ + "static/media/flatBedTruck_tomato.22fb75ea.svg";